import { render, staticRenderFns } from "./ctlItemProductNav.vue?vue&type=template&id=295cf0e6&scoped=true&"
import script from "./ctlItemProductNav.vue?vue&type=script&lang=js&"
export * from "./ctlItemProductNav.vue?vue&type=script&lang=js&"
import style0 from "./ctlItemProductNav.vue?vue&type=style&index=0&id=295cf0e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "295cf0e6",
  null
  
)

component.options.__file = "ctlItemProductNav.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib'
import { VTab } from 'vuetify/lib'
import { VTabs } from 'vuetify/lib'
installComponents(component, {
  VIcon,
  VTab,
  VTabs,
})
